/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/

import { max } from "rxjs/operators";
import { IceTypes } from "../../models/icetypes";
import { Iceutility } from "../../services/iceutility";
import { IceRect } from "../icemultimedia/IceMultimediaStroke";
import { IcecontrolSettings } from "./icesettings";

export enum ctrl_type {
  ctypLabel = 1,
  ctypEdit,
  ctypDate,
  ctypSS,
  ctypListCtrl,
  ctypHandWritingCtrl,
};

export enum fld_type {
  ftypField = 20,
  ftypCustom,
  ftypOption
};

export enum ss_ctrl_type {
  sstypSSNone = 0,
  sstypSS = 10,
  sstypList,
  sstypLabel,
  sstypEdit,
  sstypDate,
  sstypRange,
  sstypCheckBox,
  sstypHandWriting,
  sstypSummary,
  sstypSignature,
  sstypColumnSize,
  sstypSpin,
  sstypNotes,
};

export enum header_type {
  htypHorizontal = 1,
  htypVertical
};

export enum border_style {
  bstyleNone,
  bstyleThin,
  bstyleMedium,
  bstyleThick
};

export enum alignment {
  alignLeft,
  alignRight,
  alignCenter,
  alignTop,
  alignBottom,
  alignMiddle
};

export namespace basecontrol {
  export const szCLICKHERE: string = "Click Here";
  export const szCLICKARROW: string = "Click Arrow";
}

export namespace notebook_constants {
  export const szNBPAGE_TOKEN: string = "NBPAGE";
  export const szBACKCOLOR_TOKEN: string = "BACKCOLOR";	// any RGB number

  export const szNBITEM_TOKEN: string = "NBITEM";
  export const szVALUE_TOKEN: string = "VALUE";		// any value or formula
  export const szCAPTION_TOKEN: string = "CAPTION";	// any value or formula
  export const szX1_TOKEN: string = "X1";			// any number
  export const szY1_TOKEN: string = "Y1";			// any number
  export const szX2_TOKEN: string = "X2";			// any number
  export const szY2_TOKEN: string = "Y2";			// any number
  export const szWIDTH_TOKEN: string = "WIDTH";		// any numer
  export const szHEIGHT_TOKEN: string = "HEIGHT";		// any numer
  export const szSSX1_TOKEN: string = "SSX1";		// any number
  export const szSSY1_TOKEN: string = "SSY1";		// any number
  export const szSSX2_TOKEN: string = "SSX2";		// any number
  export const szSSY2_TOKEN: string = "SSY2";		// any number
  export const szTABLENAME_TOKEN: string = "TABLENAME";	// any table (standard,custom,system
  export const szFIELDNAME_TOKEN: string = "FIELDNAME";	// any field (standard,custom,system
  export const szFONTNAME_TOKEN: string = "FONTNAME";		// any installed font
  export const szFONTCOLOR_TOKEN: string = "FONTCOLOR";	// red, green, yellow, blue, cyan, black, white
  export const szFONTSIZE_TOKEN: string = "FONTSIZE";	// any number	
  export const szFONTWEIGHT_TOKEN: string = "FONTWEIGHT";	// regular - 0 or bold - 1
  export const szFONTITALIC_TOKEN: string = "FONTITALIC";	// regular - 0 or italic - 1
  export const szPAGELAYOUT_TOKEN: string = "PAGELAYOUT";	// 0 TO #
  export const szVSCROLL_TOKEN: string = "VSCROLL";	// no - 0 or yes - 1
  export const szHSCROLL_TOKEN: string = "HSCROLL";	// no - 0 or yes - 1
  export const szMULTIPG_TOKEN: string = "MULTIPG";	// 0 TO #
  export const szSHOWDATE_TOKEN: string = "SHOWDATE";	// no - 0 or yes - 1
  export const szSHOWTIME_TOKEN: string = "SHOWTIME";	// no - 0 or yes - 1
  export const szUSESUMMARY_TOKEN: string = "USESUMMARY";	// no - 0 or yes - 1
  export const szDEFAULTDATA_TOKEN: string = "DEFAULTDATA";// a list delimited by ';'
  export const szNOTEMODE_TOKEN: string = "NOTEMODE";	// 0 - either or 1 - Text or 2 - Handwriting
  export const szINPLACEEDITING_TOKEN: string = "INPLACEEDITING";	// 0 - Note Window Editing or 1 - In Place Editing	
  export const szALIGN_TOKEN: string = "ALIGN";		// "Left" - left alignment or "Center" - center alignment or "Right" - right alignment
  export const szSPINSTART_TOKEN: string = "SPINSTART";		// 0: string = 99.99
  export const szSPININCREMENT_TOKEN: string = "SPININCREMENT";	// 0: string = 99.99
  export const szBORDERLEFT_TOKEN: string = "BORDERLEFT";		// no - 0 or yes - 1
  export const szBORDERRIGHT_TOKEN: string = "BORDERRIGHT";	// no - 0 or yes - 1
  export const szBORDERTOP_TOKEN: string = "BORDERTOP";		// no - 0 or yes - 1
  export const szBORDERBOTTOM_TOKEN: string = "BORDERBOTTOM";	// no - 0 or yes - 1


  export const szTYPE_TOKEN: string = "TYPE";					// used with nbitem
  export const szLABEL_TOKEN: string = "LABEL";
  export const szEDIT_TOKEN: string = "EDIT";
  export const szDATE_TOKEN: string = "DATE";
  export const szSS_TOKEN: string = "SS";
  export const szLIST_TOKEN: string = "LIST";
    export const szLISTOPTIONS_TOKEN: string = "LISTOPTIONS";	// any value
  export const szMEDHIST_TOKEN: string = "MEDHIST";
  export const szHANDWRITING_TOKEN: string = "HANDWRITING";

  // Additional SS Types
  export const szCHECKBOX_TOKEN: string = "CHECKBOX";
  export const szRANGE_TOKEN: string = "RANGE";
  export const szSUMMARY_TOKEN: string = "SUMMARY";
  export const szSIGNATURE_TOKEN: string = "SIGNATURE";
  export const szCOLUMNSIZE_TOKEN: string = "COLUMNSIZE";
  export const szSPIN_TOKEN: string = "SPIN";
  export const szNOTES_TOKEN: string = "NOTES";

  export const szFIELDTYPE_TOKEN: string = "FIELDTYPE";			// used with nbitem, nblist, nboption
  export const szFIELD_TOKEN: string = "FIELD";
  export const szCUSTOMFIELD_TOKEN: string = "CUSTOMFIELD";
  export const szOPTIONFIELD_TOKEN: string = "OPTIONFIELD";
}

export class NotebookTableCell {
  col: number = -1;
  colSpan: number = 1;
  items: NotebookItemObject[] = [];
  ctrl: any = {};

  getItems(): NotebookItemObject[] {
    return this.items;
  }

  getClass(): any {
    if (this.colSpan != null && this.colSpan > 0) {
      switch (this.colSpan) {
        case 2: return { "col-lg-2": true };
        case 3: return { "col-lg-3": true };
        case 4: return { "col-lg-4": true };
        case 5: return { "col-lg-5": true };
        case 6: return { "col-lg-6": true };
        case 7: return { "col-lg-7": true };
        case 8: return { "col-lg-8": true };
        case 9: return { "col-lg-9": true };
        case 10: return { "col-lg-10": true };
        case 11: return { "col-lg-11": true };
        case 12: return { "col-lg-12": true };
      }
    }

    return { "col-lg-1": true };
  }

  getControl(item: NotebookItemObject): IcecontrolSettings {
    if (item.controlId.length == 0)
      item.controlId = Iceutility.guid();

    let wth = item.getWidth();
    if (wth == 0)
      wth = 100;

    if (this.ctrl[item.controlId] == null) {
      try {
        switch (item.getSSControlType()) {
          case ss_ctrl_type.sstypList:
            {
              this.ctrl[item.controlId] = new IcecontrolSettings("iceselect", { menuItems: [], width: wth.toString() + "px" }, null, null, "Item" + item.controlId, item.getCaption())
                .setControlName("Item" + item.controlId)
                .createFormControl("", []);
              break;
            }
          case ss_ctrl_type.sstypLabel:
            {
              this.ctrl[item.controlId] = new IcecontrolSettings("icelabel", { value: item.getCaption(), width: wth.toString() + "px" }, null, null, "Item" + item.controlId)
                .setControlName("Item" + item.controlId)
                .createFormControl("", []);

              break;
            }
          case ss_ctrl_type.sstypEdit:
            {
              this.ctrl[item.controlId] = new IcecontrolSettings("iceinput", { width: wth.toString() + "px" }, null, null, "Item" + item.controlId, item.getCaption())
                .setControlName("Item" + item.controlId)
                .createFormControl("", []);
              break;
            }
          case ss_ctrl_type.sstypCheckBox:
            {
              break;
            }
          case ss_ctrl_type.sstypHandWriting:
            {
              break;
            }
          case ss_ctrl_type.sstypSummary:
            {
              break;
            }
          case ss_ctrl_type.sstypSignature:
            {
              break;
            }
          case ss_ctrl_type.sstypDate:
            {
              this.ctrl[item.controlId] = new IcecontrolSettings("icedatepicker", { width: wth.toString() + "px" }, null, null, "Item" + item.controlId, item.getCaption())
                .setControlName("Item" + item.controlId)
                .createFormControl(new Date, []);
              break;
            }
          case ss_ctrl_type.sstypSpin:
            {
              break;
            }
          case ss_ctrl_type.sstypNotes:
            {
              break;
            }
        }

        if (this.ctrl[item.controlId] != null) {
          item.setAssociatedWindow(this.ctrl[item.controlId]);
        }
      }
      catch(error)
      {
        console.log(error);
      }
    }
    return this.ctrl[item.controlId];
  }
}

export class NotebookTableRow {
  cells: NotebookTableCell[] = [];
  height: number = 30;

  getCells(): NotebookTableCell[] {
    let ret: NotebookTableCell[] = [];

    let spanCnt = 0;
    for (let icell = 0; icell < this.cells.length; icell++) {
      let cell = this.cells[icell];
      if (cell == null) continue;

      if (icell == this.cells.length - 1) {
        cell.colSpan = 12 - spanCnt;
      }
      else {
        spanCnt += cell.colSpan;
      }
      ret.push(cell);
    }
    return ret;
  }
}

export class NotebookTable {
  ID: string = "";
  m_nGraphettiDefaultPageLayout: IceTypes.PageLayouts = IceTypes.PageLayouts.ploutNone;
  m_nNotebookPageIndex: number = -1;
  m_nSrcType: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
  m_colorGraphettiIndicationPresent: string = "green";
  m_colorGraphettiIndicationNotPresent: string = "white";
  m_bUseGraphetti: boolean = false;

  setNotebookPageIndex(nPageIndex: number): void {
    this.m_nNotebookPageIndex = nPageIndex;
  }

  getGraphettiDefaultPageLayout(): IceTypes.PageLayouts { return this.m_nGraphettiDefaultPageLayout; }
  setGraphettiDefaultPageLayout(plout: IceTypes.PageLayouts): void { this.m_nGraphettiDefaultPageLayout; }

  setDefaultSourceType(nSrcType: IceTypes.SourceType): void {
    this.m_nSrcType = nSrcType;
  }

  getDefaultSourceType(): IceTypes.SourceType {
    return this.m_nSrcType;
  }

  showIndication(ncol: number, nrow: number, clr: string) {
  //  this.quickSetBackColor(ncol, nrow, clr);
  //  if (this.m_colorGraphettiIndicationPresent == clr)
  //    this.quickSetTextColor(ncol, nrow, "black");
  //  else if (this.m_colorGraphettiIndicationNotPresent == clr)
  //    this.quickSetTextColor(ncol, nrow, "black");
  //  else
  //    this.quickSetTextColor(ncol, nrow, "black");
  }

  hideIndication(ncol: number, nrow: number) {
  //  this.quickSetBackColor(ncol, nrow, "white");
  //  this.quickSetTextColor(ncol, nrow, "black");
  }

  useGraphetti(ncol: number, nrow: number, bUse: boolean, bIgnoreIndication: boolean) {
    this.m_bUseGraphetti = bUse;

    if (bIgnoreIndication)
      return;

    this.showIndication(ncol, ncol, this.m_colorGraphettiIndicationNotPresent);
  }

  rows: NotebookTableRow[] = [];

  getRows(): NotebookTableRow[] {
    let ret: NotebookTableRow[] = [];

    for (let irow = 0; irow < this.rows.length; irow++) {
      let row = this.rows[irow];
      if (row == null) continue;

      ret.push(row);
    }
    return ret;
  }
}
export class NotebookItemObject {
  controlId: string = "";

  m_pWnd: any = null;
  m_pAssocWnd: IcecontrolSettings = null;
  original_rect: IceRect = new IceRect(0, 0, 0, 0);

  // Standard members
  m_position: IceRect = new IceRect(0,0,0,0);
  m_dwBackColor: string = "transparent";
  m_dwFontColor: string = "black";
  m_strFontName: string = "Arial";
  m_nFontSize: number = 8;
  m_nFontStyle: number = 0;
  m_nFontBold: boolean = false;

  m_nControlType: ctrl_type = ctrl_type.ctypEdit;
  m_strTableName = "";
  m_strFieldName = "";
  m_strCaption = "";
  m_nFieldType: fld_type = fld_type.ftypField;

  m_dblWidth: number = 0.0;
  m_dblHeight: number = 0.0;
  m_nNotePageLayout: IceTypes.PageLayouts = IceTypes.PageLayouts.ploutNotePad;
  m_nNoteMode = IceTypes.DataMode.dmEither;

  m_bVScroll: boolean = true;
  m_bHScroll: boolean = true;
  m_bMultiPage: boolean = true;
  m_bShowDate: boolean = true;
  m_bShowTime: boolean = true;
  m_bUseSummary: boolean = false;
  m_strDefaultData: string = "";

  //System.Drawing.Font m_font;

  // SS and SS->Option members
  m_nSSCtrlType: ss_ctrl_type = ss_ctrl_type.sstypSSNone;
  m_nHeaderType: header_type = header_type.htypHorizontal;
  m_strHeaderFontName: string = this.m_strFontName;
  m_dwHeaderColor: string = "black";
  m_nHeaderFontSize: number = 8;
  m_bHeaderFontBold: boolean = false;
  m_nHeaderFontStyle: number = 0;
  m_bFirstOption: boolean = false;
  m_ss_position: IceRect = new IceRect(0, 0, 0, 0);

  m_dblSpinStart: number = 0.1;
  m_dblSpinIncrement: number = 0.1;
  m_bInplaceEditing: boolean = false;

  m_nAlign: string = "left";

  m_nNextSummaryRow: number = 0;
  m_nRowLinkForItemSummary: number = -1;
  m_bLoading: boolean = false;

  m_dwBorderStyle = border_style.bstyleThin;
  m_border_color: string = "black";
  m_rectBorders: IceRect = new IceRect(0, 0, 0, 0);

  //System.Drawing.Pen m_pen;
  m_sub_items: NotebookItemObject[] = [];

  //m_font = null;
  //m_pen = null;

  copy(itemObj: NotebookItemObject): void {
    if (itemObj == null) return;

    this.m_pWnd = itemObj.m_pWnd;
    this.m_pAssocWnd = itemObj.m_pAssocWnd;
    this.m_position = itemObj.m_position;
    this.m_dwFontColor = itemObj.m_dwFontColor;
    this.m_strFontName = itemObj.m_strFontName;
    this.m_dwBackColor = itemObj.m_dwBackColor;
    this.m_nFontSize = itemObj.m_nFontSize;
    this.m_nFontBold = itemObj.m_nFontBold;
    this.m_nFontStyle = itemObj.m_nFontStyle;

    this.m_nControlType = itemObj.m_nControlType;
    this.m_strTableName = itemObj.m_strTableName;
    this.m_strFieldName = itemObj.m_strFieldName;
    this.m_strCaption = itemObj.m_strCaption;
    this.m_nFieldType = itemObj.m_nFieldType;

    // ss and ss->option
    this.m_nHeaderType = itemObj.m_nHeaderType;
    this.m_strHeaderFontName = itemObj.m_strHeaderFontName;
    this.m_dwHeaderColor = itemObj.m_dwHeaderColor;
    this.m_nHeaderFontSize = itemObj.m_nHeaderFontSize;
    this.m_bHeaderFontBold = itemObj.m_bHeaderFontBold;
    this.m_nHeaderFontStyle = itemObj.m_nHeaderFontStyle;
    this.m_bFirstOption = itemObj.m_bFirstOption;
    //m_nSSCtrlType 		= itemObj.m_nSSCtrlType; // Should be set explicidly
    this.m_ss_position = itemObj.m_ss_position;

    this.m_dblWidth = itemObj.m_dblWidth;
    this.m_dblHeight = itemObj.m_dblHeight;
    this.m_nNotePageLayout = itemObj.m_nNotePageLayout;
    this.m_nNoteMode = itemObj.m_nNoteMode;

    this.m_bVScroll = itemObj.m_bVScroll;
    this.m_bHScroll = itemObj.m_bHScroll;
    this.m_bMultiPage = itemObj.m_bMultiPage;
    this.m_bShowDate = itemObj.m_bShowDate;
    this.m_bShowTime = itemObj.m_bShowTime;
    this.m_bUseSummary = itemObj.m_bUseSummary;
    this.m_strDefaultData = itemObj.m_strDefaultData;
    this.m_nNextSummaryRow = itemObj.m_nNextSummaryRow;
    this.m_nRowLinkForItemSummary = itemObj.m_nRowLinkForItemSummary;
    this.m_bLoading = itemObj.m_bLoading;
    this.m_nAlign = itemObj.m_nAlign;

    this.m_dblSpinStart = itemObj.m_dblSpinStart;
    this.m_dblSpinIncrement = itemObj.m_dblSpinIncrement;
    this.m_bInplaceEditing = itemObj.m_bInplaceEditing;

    this.m_dwBorderStyle = itemObj.m_dwBorderStyle;
    this.m_border_color = itemObj.m_border_color;
    this.m_rectBorders = itemObj.m_rectBorders;
  }

  getTextToControlType(text: string): ctrl_type {
    return NotebookItemObject.texttoctrl_type(text);
  }
  static texttoctrl_type(text: string): ctrl_type {
    let ret: ctrl_type = ctrl_type.ctypLabel;
    if (Iceutility.isStringUndefinedNullOrEmpty(text))
      return ret;

    try {
      switch (text.toUpperCase()) {
        case notebook_constants.szLABEL_TOKEN:
          {
            ret = ctrl_type.ctypLabel;
            break;
          }
        case notebook_constants.szEDIT_TOKEN:
          {
            ret = ctrl_type.ctypEdit;
            break;
          }
        case notebook_constants.szDATE_TOKEN:
          {
            ret = ctrl_type.ctypDate;
            break;
          }
        case notebook_constants.szLIST_TOKEN:
          {
            ret = ctrl_type.ctypListCtrl;
            break;
          }
        case notebook_constants.szSS_TOKEN:
          {
            ret = ctrl_type.ctypSS;
            break;
          }
        case notebook_constants.szHANDWRITING_TOKEN:
          {
            ret = ctrl_type.ctypHandWritingCtrl;
            break;
          }
      }
    }
    catch
    {
      ret = ctrl_type.ctypLabel;
    }
    return ret;
  }

  getTextToSSType(text: string): ss_ctrl_type {
    return NotebookItemObject.texttoss_ctrl_type(text);
  }
  static texttoss_ctrl_type(text: string): ss_ctrl_type {
    let ret: ss_ctrl_type = ss_ctrl_type.sstypLabel;
    if (Iceutility.isStringUndefinedNullOrEmpty(text))
      return ret;

    try {
      switch (text.toUpperCase()) {
        case notebook_constants.szLIST_TOKEN:
          {
            ret = ss_ctrl_type.sstypList;
            break;
          }
        case notebook_constants.szLABEL_TOKEN:
          {
            ret = ss_ctrl_type.sstypLabel;
            break;
          }
        case notebook_constants.szEDIT_TOKEN:
          {
            ret = ss_ctrl_type.sstypEdit;
            break;
          }
        case notebook_constants.szCHECKBOX_TOKEN:
          {
            ret = ss_ctrl_type.sstypCheckBox;
            break;
          }
        case notebook_constants.szRANGE_TOKEN:
          {
            ret = ss_ctrl_type.sstypRange;
            break;
          }
        case notebook_constants.szHANDWRITING_TOKEN:
          {
            ret = ss_ctrl_type.sstypHandWriting;
            break;
          }
        case notebook_constants.szSUMMARY_TOKEN:
          {
            ret = ss_ctrl_type.sstypSummary;
            break;
          }
        case notebook_constants.szSIGNATURE_TOKEN:
          {
            ret = ss_ctrl_type.sstypSignature;
            break;
          }
        case notebook_constants.szCOLUMNSIZE_TOKEN:
          {
            ret = ss_ctrl_type.sstypColumnSize;
            break;
          }
        case notebook_constants.szDATE_TOKEN:
          {
            ret = ss_ctrl_type.sstypDate;
            break;
          }
        case notebook_constants.szSPIN_TOKEN:
          {
            ret = ss_ctrl_type.sstypSpin;
            break;
          }
        case notebook_constants.szNOTES_TOKEN:
          {
            ret = ss_ctrl_type.sstypNotes;
            break;
          }
      }
    }
    catch
    {
      ret = ss_ctrl_type.sstypLabel;
    }
    return ret;
  }

  static texttofld_type(text: string) {
    let ret: fld_type = fld_type.ftypCustom;
    if (Iceutility.isStringUndefinedNullOrEmpty(text))
      return ret;

    try {
      switch (text.toUpperCase()) {
        case notebook_constants.szFIELD_TOKEN:
          {
            ret = fld_type.ftypField;
            break;
          }
        case notebook_constants.szCUSTOMFIELD_TOKEN:
          {
            ret = fld_type.ftypCustom;
            break;
          }
        case notebook_constants.szOPTIONFIELD_TOKEN:
          {
            ret = fld_type.ftypOption;
            break;
          }
      }
    }
    catch
    {
      ret = fld_type.ftypCustom;
    }
    return ret;
  }

  static header_typetotext(stype: header_type): string {
    let text: string = "";
    try {
      text = stype.toString();
    }
    catch
    {
      text = "";
    }
    return text;
  }
  static texttoheader_type(text: string): header_type {
    let ret: header_type = header_type.htypHorizontal;
    if (Iceutility.isStringUndefinedNullOrEmpty(text))
      return ret;

    try {
      ret = <header_type>Iceutility.toLong(text);
    }
    catch
    {
      ret = header_type.htypHorizontal;
    }
    return ret;
  }

  static alignmenttotext(stype: alignment): string {
    let text: string = "";
    try {
      text = stype.toString();
    }
    catch
    {
      text = "";
    }
    return text;
  }
  static texttoalignment(text: string): alignment {
    let ret: alignment = alignment.alignLeft;
    if (Iceutility.isStringUndefinedNullOrEmpty(text))
      return ret;

    try {
      ret = <alignment>Iceutility.toLong(text);
    }
    catch
    {
      ret = alignment.alignLeft;
    }
    return ret;
  }

  static border_styletotext(stype: border_style): string {
    let text: string = "";
    try {
      text = stype.toString();
    }
    catch
    {
      text = "";
    }
    return text;
  }
  static texttoborder_style(text: string): border_style {
    let ret: border_style = border_style.bstyleNone;
    if (Iceutility.isStringUndefinedNullOrEmpty(text))
      return ret;

    try {
      ret = <border_style>Iceutility.toLong(text);
    }
    catch
    {
      ret = border_style.bstyleNone;
    }
    return ret;
  }

  setBackColor(dwColor: string): void {
    this.m_dwBackColor = dwColor;
  }
  getBackColor(): string {
    return this.m_dwBackColor;
  }

  setPosition(position: IceRect): void {
    this.m_position = position;
  }
  getPosition(): IceRect {
    return this.m_position;
  }

  setX1(nval: number): void {
    this.m_position.left = nval;
  }

  setY1(nval: number): void {
    this.m_position.top = nval;
  }

  setX2(nval: number): void {
    let width: number = nval - this.m_position.left;
    this.m_position.right = nval;
  }

  setY2(nval: number): void {
    let height = nval - this.m_position.top;
    this.m_position.bottom = nval;
  }

  createSS(): NotebookTable {
    let grid: NotebookTable = null;
    if (this.m_pWnd != null) return this.m_pWnd;
    try {

      grid = new NotebookTable();
      
      let totalRows = 1;
      for (let i = 0; i < this.m_sub_items.length; i++) {
        let sitem = this.m_sub_items[i];
        if (sitem == null) continue;

        let irow = sitem.m_ss_position.top;
        if (irow <= 0) continue;

        let trow: NotebookTableRow = null;
        if (grid.rows[irow] == null) {
          trow = new NotebookTableRow();
          grid.rows[irow] = trow;
        }
        else {
          trow = grid.rows[irow];
        }

        let icol = sitem.m_ss_position.left;
        if (icol <= 0) continue;

        let tcol: NotebookTableCell = null;
        if (trow.cells[icol] == null) {
          tcol = new NotebookTableCell();
          tcol.col = icol;
          tcol.items.push(sitem);
          trow.cells[icol] = tcol;
        }
        else {
          tcol = trow.cells[icol];
          tcol.items.push(sitem);
        }

        if (sitem.getSSControlType() == ss_ctrl_type.sstypRange) {
          let rows = sitem.m_ss_position.bottom - sitem.m_ss_position.top;
          if (rows > 0) {
            // calculate height of row
            trow.height = Math.max(trow.height, 30 * (rows + 1));
          }
          let cols = sitem.m_ss_position.right - sitem.m_ss_position.left;
          if (cols > 0) {
            // calculate span of col
            tcol.colSpan = Math.max(tcol.colSpan, (cols + 1));
          }
        }
      }
      this.m_pWnd = grid;
    }
    catch (error)
    {
      console.log(error);
    }
    return grid;
  }

  getWnd(): any {
    return this.m_pWnd;
  }

  // A window that is used in conjuction with this item,
  // this is not the window that displays the items data
  setAssociatedWindow(pWnd: IcecontrolSettings): void {
    this.m_pAssocWnd = pWnd;
  }

  getAssociatedWindow(): IcecontrolSettings {
    return this.m_pAssocWnd;
  }

  setFontColor(dwFontColor: string): void {
    this.m_dwFontColor = dwFontColor;
  }

  setFontName(lpszFontName: string): void {
    this.m_strFontName = lpszFontName;
  }

  setFontSize(nFontSize: number): void {
    this.m_nFontSize = nFontSize;
  }

  setFontWeight(bFontBold: boolean): void {
    this.m_nFontBold = bFontBold;
  }

  setFontStyle(nFontStyle: number): void {
    this.m_nFontStyle = nFontStyle;
  }

  getFontColor(): string {
    return this.m_dwFontColor;
  }

  getFontName(): string {
    return this.m_strFontName;
  }

  getFontSize(): number {
    return this.m_nFontSize;
  }

  getFontWeight(): boolean {
    return this.m_nFontBold;
  }

  getFontStyle(): number  {
    return this.m_nFontStyle;
  }

  setControlType(nCtrlType: ctrl_type): void {
    this.m_nControlType = nCtrlType;
  }

  getControlType(): ctrl_type {
    return this.m_nControlType;
  }

  setTableName(lpszName: string): void {
    this.m_strTableName = lpszName;
  }

  getTableName(): string {
    return this.m_strTableName;
  }

  setFieldName(lpszName: string): void {
    this.m_strFieldName = lpszName;
  }

  getFieldName(): string {
    return this.m_strFieldName;
  }

  setCaption(lpszCaption: string): void {
    this.m_strCaption = lpszCaption;
  }

  getCaption(): string {
    return this.m_strCaption;
  }

  // Option members
  setFieldType(nFieldType: fld_type): void {
    this.m_nFieldType = nFieldType;
  }

  public getFieldType(): fld_type {
    return this.m_nFieldType;
  }

  setWidth(dblwidth: number): void {
    this.m_dblWidth = dblwidth;
  }

  getWidth(): number {
    return this.m_dblWidth;
  }

  setHeight(dblheight: number): void {
    this.m_dblHeight = dblheight;
  }

  getHeight(): number {
    return this.m_dblHeight;
  }

  setLoading(bLoading: boolean = true): void {
    this.m_bLoading = bLoading;
  }

  getLoading(): boolean {
    return this.m_bLoading;
  }

  setAlign(nAlign: string): void {
    this.m_nAlign = nAlign;
  }

  getAlign(): string {
    return this.m_nAlign;
  }

  /////////////////////////////////////////////////////
  // SS and SS->Option members
  setSSControlType(nSSCtrlType: ss_ctrl_type): void {
    this.m_nSSCtrlType = nSSCtrlType;
  }

  getSSControlType(): ss_ctrl_type {
    return this.m_nSSCtrlType;
  }

  setSSPosition(position: IceRect): void {
    this.m_ss_position = position;
  }

  getSSPosition(): IceRect {
    return this.m_ss_position;
  }

  setSSX1(nval: number): void {
    this.m_ss_position.left = nval;
  }

  setSSY1(nval: number): void {
    this.m_ss_position.top = nval;
  }

  setSSX2(nval: number): void {
    this.m_ss_position.right = nval;
  }

  setSSY2(nval: number): void {
    this.m_ss_position.bottom = nval;
  }

  setSSRowAdjustment(nval: number): void {
    this.setSSY1(this.m_ss_position.top + nval);
    this.setSSY2(this.m_ss_position.bottom + nval);
  }

  setFirstOption(bFirst: boolean): void {
    this.m_bFirstOption = bFirst;
  }

  getFirstOption(): boolean {
    return this.m_bFirstOption;
  }

  setHeaderType(nHeaderType: header_type): void {
    this.m_nHeaderType = nHeaderType;
  }

  getHeaderType(): header_type {
    return this.m_nHeaderType;
  }

  setHeaderFontName(lpszFontName: string): void {
    this.m_strHeaderFontName = lpszFontName;
  }

  getHeaderFontName(): string {
    return this.m_strHeaderFontName;
  }

  setHeaderFontColor(dwColor: string): void {
    this.m_dwHeaderColor = dwColor;
  }

  getHeaderFontColor(): string {
    return this.m_dwHeaderColor;
  }

  setHeaderFontSize(nFontSize: number): void {
    this.m_nFontSize = nFontSize;
  }

  getHeaderFontSize(): number {
    return this.m_nFontSize;
  }

  setHeaderFontWeight(bBold: boolean): void {
    this.m_bHeaderFontBold = bBold;
  }

  getHeaderFontWeight(): boolean {
    return this.m_bHeaderFontBold;
  }

  setHeaderFontStyle(nFontStyle: number): void {
    this.m_nHeaderFontStyle = nFontStyle;
  }

  getHeaderFontStyle(): number {
    return this.m_nHeaderFontStyle;
  }

  setNotePageLayout(lnPageLayout: IceTypes.PageLayouts): void {
    this.m_nNotePageLayout = lnPageLayout;
  }

  getNotePageLayout(): IceTypes.PageLayouts {
    return this.m_nNotePageLayout;
  }

  setVScroll(bVal: boolean): void {
    this.m_bVScroll = bVal;
  }

  getVScroll(): boolean {
    return this.m_bVScroll;
  }
  setHScroll(bVal: boolean): void {
    this.m_bHScroll = bVal;
  }

  getHScroll(): boolean {
    return this.m_bHScroll;
  }

  setMultiPage(bVal: boolean): void {
    this.m_bMultiPage = bVal;
  }

  getMultiPage(): boolean {
    return this.m_bMultiPage;
  }

  setShowDate(bVal: boolean): void {
    this.m_bShowDate = bVal;
  }

  getShowDate(): boolean {
    return this.m_bShowDate;
  }

  setShowTime(bVal: boolean): void {
    this.m_bShowTime = bVal;
  }

  getShowTime(): boolean {
    return this.m_bShowTime;
  }

  setUseSummary(bVal: boolean): void {
    this.m_bUseSummary = bVal;
  }

  getUseSummary(): boolean {
    return this.m_bUseSummary;
  }

  setDefaultData(lpszData: string): void {
    this.m_strDefaultData = lpszData;
  }

  getDefaultData(): string {
    return this.m_strDefaultData;
  }

  setNoteMode(nNoteMode: IceTypes.DataMode) {
    this.m_nNoteMode = nNoteMode;
  }

  getNoteMode(): IceTypes.DataMode {
    return this.m_nNoteMode;
  }

  setNextSummaryRow(nRow: number): void {
    this.m_nNextSummaryRow = nRow;
  }

  getNextSummaryRow(): number {
    return this.m_nNextSummaryRow;
  }

  setRowLinkForItemSummary(nRow: number): void {
    this.m_nRowLinkForItemSummary = nRow;
  }

  getRowLinkForItemSummary(): number  {
    return this.m_nRowLinkForItemSummary;
  }

  setSpinStart(dblSpinStart: number): void {
    this.m_dblSpinStart = dblSpinStart;
  }

  getSpinStart(): number {
    return this.m_dblSpinStart;
  }

  setSpinIncrement(dblSpinIncrement: number): void {
    this.m_dblSpinIncrement = dblSpinIncrement;
  }

  getSpinIncrement(): number {
    return this.m_dblSpinIncrement;
  }

  getBorderStyle(): border_style {
    return this.m_dwBorderStyle;
  }

  setInplaceEditing(bInplace: boolean) {
    this.m_bInplaceEditing = bInplace;
  }

  getInplaceEditing(): boolean {
    return this.m_bInplaceEditing;
  }

  setBorderStyle(dwBorderStyle: border_style) {
    this.m_dwBorderStyle = dwBorderStyle;
  }

  getBorders(): IceRect {
    return this.m_rectBorders;
  }

  setBorders(rectBorders: IceRect): void {
    this.m_rectBorders = rectBorders;
  }

  setBorderColor(cref: string) {
    this.m_border_color = cref;
  }

  getBorderColor(): string {
    return this.m_border_color;
  }

  getOriginalRect(): IceRect { return this.original_rect; }

  getSubItems(): NotebookItemObject[] {
    return this.m_sub_items;
  }

  resetSubItems(): void {
    if (this.m_sub_items == null || this.m_sub_items.length == 0)
      return;

    this.m_sub_items = [];
  }

  addSubItem(ritemObj: NotebookItemObject): NotebookItemObject {
    let pitemObj: NotebookItemObject = null;
    try {
      if (this.m_sub_items == null)
          this.m_sub_items = [];

      pitemObj = new NotebookItemObject();
      if (ritemObj != null) pitemObj.copy(ritemObj);
      this.m_sub_items.push(pitemObj);
    }
    catch (error)
    {
      if (pitemObj != null) {
        pitemObj = null;
      }
      console.log(error);
    }
    return pitemObj;
  }

  getSubItem(nindex: number): NotebookItemObject {
    if (nindex >= 0 && nindex < this.m_sub_items.length) {
      let pitemObj = this.m_sub_items[nindex];
      return pitemObj;
    }
    return null;
  }

  getSubItemByFieldName(lpszTableName: string, lpszColumnName: string): NotebookItemObject {
    for (let i = 0; i < this.m_sub_items.length; i++) {
      let pObj = this.m_sub_items[i];
      if (pObj != null) {
        if (pObj.m_strTableName.toUpperCase() == lpszTableName.toUpperCase()
          && pObj.m_strFieldName.toUpperCase() == lpszColumnName.toUpperCase()) {
          return pObj;
        }
        else {
          for (let iSubItem = 0; iSubItem < pObj.m_sub_items.length; iSubItem++) {
            let pItemTest = pObj.m_sub_items[iSubItem];
            if (pItemTest != null) {
              if (pItemTest.m_strTableName.toUpperCase() == lpszTableName.toUpperCase()
                && pItemTest.m_strFieldName.toUpperCase() == lpszColumnName.toUpperCase()) {
                return pItemTest;
              }
            }
          }
        }
      }
    }
    return null;
  }

  removeSubItem(pItem: NotebookItemObject): void {
    for (let i = 0; i < this.m_sub_items.length; i++) {
      let pObj = this.m_sub_items[i];
      if (pObj == pItem) {
        this.m_sub_items[i] = null;
        delete this.m_sub_items[i];
        return;
      }
    }
  }
  
  getSubItemCount(): number {
    return this.m_sub_items.length;
  }
}
